
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';

import useExperienciaSectorProductivo from "../hooks/useExperienciaSectorProductivo"
import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
// import { formatearFecha } from '../functions/formatearFecha';
import { yearActual } from '../functions/fechaMenos18';

const ExperienciaSectorProductivo = () => {


    const { isOpen, abrirModal, cerrarModal, guardarExp, setformExp,
        formExp, exp, formatearFecha,
        llenarFormExp, cargando, borrarExp } = useExperienciaSectorProductivo();


    return (
        <div className="my-4">
            <p className="lead text-center">
                Experiencia en el sector productivo
            </p>

            <Button variant="info" onClick={ abrirModal }>
                Agregar experiencia
            </Button>

            <div className='table-responsive my-4'>
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th className='text-center'>Inicio</th>
                            <th className='text-center'>Final</th>
                            <th className='text-center'>Puesto</th>
                            <th className='text-center'>Empresa</th>
                            <th className='text-center'>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        { exp.map(( e, i )=> (
                            <tr key={ i }>
                                <td className='text-center'>
                                    { formatearFecha(e.inicio) }
                                </td>
                                <td className='text-center'>
                                    { formatearFecha(e.final) }
                                </td>
                                <td className='text-center'>
                                    { e.puesto }
                                </td>
                                <td className='text-center'>
                                    { e.empresa }
                                </td>
                                <td className='text-center'>
                                    <ButtonGroup>
                                        <TooltipHover tooltipText='Editar información'>
                                            <Button variant='warning' onClick={ () => llenarFormExp( e ) }>
                                                <PencilIcon/>
                                            </Button>
                                        </TooltipHover>
                                        <TooltipHover tooltipText='Eliminar'>
                                            <Button variant='danger' onClick={ () => borrarExp( e.pk_exp ) }>
                                                <DeleteIcon/>
                                            </Button>
                                        </TooltipHover>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>




            <Modal
                show={ isOpen }
                onHide={ cerrarModal }
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className=''
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Administrar registros</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Alert variant='success'>
                        Complete los siguientes campos para registrar su experiencia en el sector productivo.
                        <br/>
                        Indica en meses cuando empezó y terminó tu relación laboral
                    </Alert>

                    <Row>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput3"
                                label="Inicio"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="month"
                                    min="1900"
                                    step="1"
                                    placeholder=" "
                                    autoComplete='off'
                                    max={ yearActual() }
                                    value={ formExp.inicio }
                                    onChange={ e => setformExp({ ...formExp, inicio: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput3"
                                label="Final"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="month"
                                    min="1900"
                                    step="1"
                                    placeholder=" "
                                    autoComplete='off'
                                    max={ yearActual() }
                                    value={ formExp.final }
                                    onChange={ e => setformExp({ ...formExp, final: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput3"
                                label="Puesto"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formExp.puesto }
                                    onChange={ e => setformExp({ ...formExp, puesto: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput3"
                                label="Empresa"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formExp.empresa }
                                    onChange={ e => setformExp({ ...formExp, empresa: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={ cerrarModal }>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={ guardarExp } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </Modal.Footer>
            </Modal>
            <hr className='m-5'/>
        </div>
    )
}

export default ExperienciaSectorProductivo
